let isWebView: boolean = false;
let deviceVersion: string = '';
let storeType: string = '';
let appType: string = '';
let webViewType: 'Android' | 'iOS' | '' = '';

function getUserAgentInfo() {
  let os: 'Unknown OS' | 'windows' | 'macos' | 'linux' | 'android' | 'ios' = 'Unknown OS';
  let browser: 'Unknown Browser' | 'edge' | 'chrome' | 'safari' | 'firefox' | 'opera' = 'Unknown Browser';
  let isMobile;

  let isChatApp;
  let chatAppVersion;

  if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined') {
    const { userAgent } = window.navigator;

    if (/android/i.test(userAgent)) {
      os = 'android';
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      os = 'ios';
    } else if (/Win/i.test(userAgent)) {
      os = 'windows';
    } else if (/Mac/i.test(userAgent)) {
      os = 'macos';
    } else if (/Linux/i.test(userAgent)) {
      os = 'linux';
    }

    if (/Edg/i.test(userAgent)) {
      browser = 'edge';
    } else if (/OPR|Opera/i.test(userAgent)) {
      browser = 'opera';
    } else if (/Firefox/i.test(userAgent)) {
      browser = 'firefox';
    } else if (/Chrome/i.test(userAgent) && !/Edg/i.test(userAgent) && !/OPR/i.test(userAgent)) {
      browser = 'chrome';
    } else if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent) && !/Edg/i.test(userAgent)) {
      browser = 'safari';
    }

    isMobile = os === 'android' || os === 'ios';

    const patternChatApp = /\[chatApp\;([^\/]+)\/([^\;]+)\;{0,1}\]/;
    const chatAppMatch = patternChatApp.exec(userAgent);

    if (chatAppMatch && chatAppMatch.length >= 2) {
      isChatApp = true;
      chatAppVersion = chatAppMatch[2];
    }

    if (!isWebView) {
      const patternAndroidApp = /\[AndroidAPP\;([^\/]+)\/([^\;]+)\;(onestore|playstore)*\;(cast|player)*\;{0,1}\]/;
      const androidAppMatch = patternAndroidApp.exec(userAgent);

      if (androidAppMatch && androidAppMatch.length >= 3) {
        isWebView = true;
        deviceVersion = androidAppMatch[2];
        storeType = androidAppMatch[3];
        appType = androidAppMatch[4];
        webViewType = 'Android';
      }

      const patternIOSApp = /\[iOSAPP\;([^\/]+)\/([^\;]+)\;(appstore)*\;(cast|player)*\;{0,1}\]/;
      const IOSAppMatch = patternIOSApp.exec(userAgent);

      if (IOSAppMatch && IOSAppMatch.length >= 3) {
        isWebView = true;
        deviceVersion = IOSAppMatch[2];
        storeType = IOSAppMatch[3];
        appType = IOSAppMatch[4];
        webViewType = 'iOS';
      }
    }
  }

  return {
    os,
    browser,
    isMobile,
    isChatApp,
    chatAppVersion,
    isWebView,
    deviceVersion,
    storeType,
    appType,
    webViewType,
  };
}

export default getUserAgentInfo;
